import React from 'react';

import {Route, Routes, useParams} from "react-router-dom";
import {useLocation, useNavigate} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import UserStates from "../UserStates";
import Charger from "../Charger/rt";
import PrefabsRT from "../Prefabs/rt/PrefabsRT";
import ArchiveRT from "../Archive/rt/ArchiveRT";
import WhiteListManagement from "../WhiteListManagement";
import {Box, Divider, MenuList, Stack, Toolbar} from "@mui/material";
import CollapsibleDrawer from "../../components/Common/Layout/CollapsibleDrawer";
import NavMenuItem from "../../components/Common/Layout/NavMenuItem";
import {useMenu} from "../../core/context/menuContext";
import AiTicketsDrawer from "../../components/AiTickets/AiTicketsDrawer";

import DashboardRT from "../Dashboard/rt";
import UserStatesRT from "../UserStates/rt";
import ChargeManagement from "../ChargeManagement/ba";
import {useGetGuidMapRTQuery} from "../../core/api/rogerthat-charge-api";
import AllRtChargerLogs from "../ChargerLogs/rt/AllRtChargerLogs";
import AdvancedSearch from "../AdvancedSearch";
import {isEmpty} from "../../core/utils/StringUtils";
import {getDeviceIdAbsentWarning} from "../../core/utils/constants";
import SearchBarRT from "../Search/SearchRT";
import AdvancedSearchRT from "../AdvancedSearch/AdvancedSearchRT";
import PersonalData from "../PersonalData";
import AiZendeskSettings from "../AiZendesk";

export default function MainRT() {
    const {game, action} = useParams();
    const CommonData = useSelector((state) => state.data.CommonData)
    const mode = useSelector((state) => state.data.SourceMode)
    let deviceId = CommonData.deviceId ? CommonData.deviceId : '';
    let vendorId = CommonData.stateId ? CommonData.stateId : '';


    const location = useLocation();
    const dispatch = useDispatch();
    let navigate = useNavigate();

    if (deviceId != '' && deviceId != CommonData.deviceId) {
        dispatch({
            type: "SET_DEVICE_ID",
            payload: {deviceId},
        });
    } else {
        if (typeof CommonData.deviceId == 'string') {
            deviceId = CommonData.deviceId
        }
    }

    // expanded/collapsed by the burger button in the Header
    const {open: menuOpen} = useMenu()

    const main_menu = [
        {
            to: '/' + game + '/dashboard/' + deviceId + '?vendorId=' +vendorId,
            path: 'dashboard/:deviceId?',
            title: 'Dashboard',
            element: <DashboardRT/>
        },
        {
            to: '/' + game + '/state/' + deviceId + '?vendorId=' +vendorId,
            path: 'state/:deviceId?/:tab?/:subtab?',
            title: 'UserStates',
            element: <UserStatesRT/>,
            // disabled: deviceId == ''
        },
    ];
    const state_menu = [

        {to: '/' + game + '/charger/' + deviceId + '?vendorId=' +vendorId, path: 'charger/:deviceId?', title: 'Charger', element: <Charger/>},

        {to: '/' + game + '/logs', path: 'logs', title: 'ChargerLogs', element: <AllRtChargerLogs/>},
        //{to:'reports', title:'Reports',component:'<Reports />'},

    ]
    const common_menu = [
        {
            to: '/' + game + '/prefabs/' + deviceId + '?vendorId=' +vendorId,
            path: "prefabs/:deviceId?",
            title: 'Prefabs',
            element: <PrefabsRT game={game}/>
        },
        {
            to: '/' + game + '/archive/' + deviceId + '?vendorId=' +vendorId,
            path: "archive/:deviceId?",
            title: 'Archive',
            element: <ArchiveRT game={game}/>
        },
        {
            to: '/' + game + '/search',
            path: "search",
            title: 'Search',
            element: <AdvancedSearchRT game={game}/>
        }
    ]
    const admin_menu = [
        {
            to: '/' + game + '/chargeManagement',
            path: "chargeManagement",
            title: 'Charge Management',
            element: <ChargeManagement game={game}/>
        },
        {
            to: '/' + game + '/whitelistManagement',
            path: "whitelistManagement",
            title: 'White list management',
            element: <WhiteListManagement/>
        },
        ...(mode.isProd ? [{
            to: `/${game}/personal-data`,
            path: "personal-data",
            title: "GDPR",
            element: <PersonalData initialProject="roger-that" />
        }] : []),
        ...(mode.isProd ? [{
            to: `/${game}/ai-zendesk`,
            path: "ai-zendesk",
            title: "Zendesk",
            element: <AiZendeskSettings game={game} />
        }] : [])
    ]

    // first path segment ("dashboard/:deviceId?" -> "dashboard") matches the :action route param
    const isActive = (object) => object.path.split("/")[0] === action

    let menu = [
        ...main_menu,
        ...state_menu,
        ...common_menu
    ]

    const deviceIdIsEmpty = (isEmpty(deviceId) || typeof deviceId == 'object') && isEmpty(vendorId);

    const routes = (
        <Route>

            {menu.map((object) => (
                <Route path={object.path} element={object.element}/>
            ))}
            {admin_menu.map((object) => (
                <Route path={object.path} element={object.element}/>
            ))}
        </Route>
    );


    // Stack, not Box: App.css has a global ".MuiBox-root a" rule that would break the vertical menu
    return (
        <Stack direction="row" className="wrapper" sx={{flexGrow: 1, minWidth: 0, width: "100%"}}>
            <CollapsibleDrawer anchor="left" width={230} open={menuOpen} label="menu" hideScrollbar>
                <MenuList>
                    {menu.map((object) => (
                        <React.Fragment key={object.path}>
                            <NavMenuItem {...object} open={menuOpen} selected={isActive(object)}/>
                            {object?.isDividerAfter && <Divider/>}
                        </React.Fragment>
                    ))}
                    <Divider/>

                    {admin_menu.map((object) => (
                        <NavMenuItem key={object.path} {...object} open={menuOpen} selected={isActive(object)}/>
                    ))}
                </MenuList>
            </CollapsibleDrawer>
                <Box component="main"
                     sx={{flexGrow: 1, minWidth: 0, p: 3}}
                >
                    <Toolbar/>

                    {['chargeManagement', 'whitelistManagement', 'search', 'personal-data', 'ai-zendesk'].indexOf(action) == -1 &&
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                mb: 2
                            }}>
                            <SearchBarRT />
                        </Box>
                    }

                    <Box sx={{
                        width: "100%",
                        mb: 2
                    }}>
                        {(deviceIdIsEmpty && (action == 'dashboard' || action=='state') ) ? getDeviceIdAbsentWarning() :
                            <Routes>
                                {main_menu.map((object) => (
                                    <Route path={object.path} element={object.element}/>
                                ))}
                            </Routes>
                        }
                        <Routes>
                            {state_menu.map((object) => (
                                <Route path={object.path} element={object.element}/>
                            ))}
                            {common_menu.map((object) => (
                                <Route path={object.path} element={object.element}/>
                            ))}
                            {admin_menu.map((object) => (
                                <Route path={object.path} element={object.element}/>
                            ))}
                        </Routes>

                    </Box>
                </Box>
            <AiTicketsDrawer/>
        </Stack>
    );
}
